import { render, staticRenderFns } from "./cameraDetector.vue?vue&type=template&id=ff385fc6&scoped=true"
import script from "./cameraDetector.vue?vue&type=script&lang=js"
export * from "./cameraDetector.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=ff385fc6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff385fc6",
  null
  
)

export default component.exports